import { Component } from '@angular/core';
import { OfficeholderGroupModel } from "../../../../../../models/officeholder-group-model";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { DefaulValuePipe } from "../../../../../../../../shared/pipes/defaultValuePipe";

type CellRendererParams = ICellRendererParams<OfficeholderGroupModel, string> & { pendingButtonState: boolean | undefined };

@Component({
  selector: 'app-ag-officeholder-name',
  standalone: true,
  templateUrl: 'ag-officeholder-name.component.html',
  imports: [DefaulValuePipe],
  styleUrl: 'ag-officeholder-name.component.scss'
})
export class AgOfficeholderNameComponent implements ICellRendererAngularComp {
  model!: OfficeholderGroupModel;
  pendingButtonState = false;

  agInit(params: CellRendererParams): void {
    this.updateCell(params);
  }

  refresh(params: CellRendererParams): boolean {
    return this.updateCell(params);
  }

  updateCell(params: CellRendererParams): boolean {
    this.model = params.data!;
    this.pendingButtonState = params.pendingButtonState ?? false;
    return true;
  }

}
